import { createElement } from 'src/app/core/helpers/dom';
import { ECustomFieldType } from 'src/app/project/modules/custom-fields/custom-field-types-enums';
import { TCustomField } from 'src/app/project/modules/custom-fields/custom-fields.model';
import { GET_CUSTOM_FIELDS } from 'src/app/project/modules/custom-fields/custom-fields.store';
import { logErrorInSentry } from 'src/app/project/modules/errors/response-error';
import { EWorkspaces } from 'src/app/project/modules/workspace/workspaces.enum';
import { TColumn } from '../../columns/column.model';
import { GET_TABLE } from '../../table.ui.store';
import { createCheckboxElement } from './create-checkbox-element';
import { createCostElement } from './create-cost-element';
import { createDateElement } from './create-date-element';
import { createDefaultElement } from './create-default-element';
import { createNumbersElement } from './create-numbers-element';
import { createPercentageElement } from './create-percentage-element';
import { createRichTextElement } from './create-rich-text-element';
import { createTimeElement } from './create-time-element';
import { createTimelineElement } from './create-timeline-element';

export function createCustomFieldElement(_index: number, _column: TColumn): HTMLElement {
  const table = GET_TABLE();

  // FIXME investigate why somethimes this field doesn't exist while refactoring the logic
  if (!_column.customFieldIds) {
    logErrorInSentry({ message: 'Missing custom fields in column: ' + JSON.stringify(_column) });

    return createDefaultElement(_index, _column, null);
  }

  const expandedColumnIds =
    table.combineCustomFieldsService?.expandCustomFieldIds(
      table.workspaceId || EWorkspaces.OVERVIEW,
      _column.customFieldIds,
    ) ?? _column.customFieldIds;
  const column: TColumn = { ..._column, customFieldIds: expandedColumnIds };

  const customFieldIndex = Object.keys(table.getPoints()[_index].customFieldsMap).find(
    (customFieldId) => expandedColumnIds.includes(customFieldId),
  );

  const pointCustomField = table.getPoints()[_index].customFieldsMap?.[customFieldIndex];

  if (!pointCustomField) {
    return createDefaultElement(_index, column, null);
  }

  const customField = GET_CUSTOM_FIELDS()[pointCustomField.customFieldTemplateId];

  let customFieldElement: HTMLElement = createElement('div');
  customFieldElement.innerHTML = '';

  switch (customField?.type) {
    case ECustomFieldType.DATE:
      customFieldElement = createDateElement(_index, column, pointCustomField);
      break;
    case ECustomFieldType.COST:
      customFieldElement = createCostElement(_index, column, pointCustomField);
      break;
    case ECustomFieldType.TIME:
      customFieldElement = createTimeElement(_index, column, pointCustomField);
      break;
    case ECustomFieldType.RICHTEXT:
      customFieldElement = createRichTextElement(_index, column, pointCustomField);
      break;
    case ECustomFieldType.CHECKBOX:
      customFieldElement = createCheckboxElement(_index, column, pointCustomField);
      break;
    case ECustomFieldType.PERCENTAGE:
      customFieldElement = createPercentageElement(_index, column, pointCustomField);
      break;
    case ECustomFieldType.FORMULA:
      const workspaceCustomField: TCustomField =
        GET_CUSTOM_FIELDS()[pointCustomField.customFieldTemplateId];

      switch (workspaceCustomField?.outputType) {
        case ECustomFieldType.NUMBERS:
          customFieldElement = createNumbersElement(_index, column, pointCustomField);
          break;
        case ECustomFieldType.COST:
          customFieldElement = createCostElement(_index, column, pointCustomField);
          break;
        case ECustomFieldType.PERCENTAGE:
          customFieldElement = createPercentageElement(_index, column, pointCustomField);
          break;
      }
      break;

    case ECustomFieldType.NUMBERS:
      customFieldElement = createNumbersElement(_index, column, pointCustomField);
      break;
    case ECustomFieldType.TIMELINE:
      customFieldElement = createTimelineElement(_index, column, pointCustomField);
      break;
    default:
      customFieldElement = createDefaultElement(_index, column, pointCustomField);
      break;
  }

  return customFieldElement;
}
